import React from "react";
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Switch,
} from "@mui/material";

interface Props {
  checked?: boolean;
  onChange: (checked: boolean) => void;
  /**
   * The calendar event title members see when this is on. Omitted for a
   * series, whose occurrences can each carry their own title.
   */
  calendarTitle?: string;
}

export const UseCalendarTitleField: React.FC<Props> = ({
  checked,
  onChange,
  calendarTitle,
}) => (
  <FormControl fullWidth margin="normal">
    <FormControlLabel
      control={
        <Switch
          checked={checked ?? false}
          onChange={(e) => onChange(e.target.checked)}
        />
      }
      label="Use Calendar Title"
    />
    <FormHelperText>
      {calendarTitle
        ? `When checked, members see this meeting as “${calendarTitle}”`
        : "When checked, members see each occurrence under its calendar event title"}{" "}
      instead of its meeting type's title. The meeting type still supplies the
      description, icon, and agenda.
    </FormHelperText>
  </FormControl>
);
